module.exports = __webpack_public_path__ + "static/WEDDING E&M-78-95a74dcc5bb8f442eacf54d14346e629.jpg";